export default __webpack_public_path__ + "assets/images/amex-white.0b6ee6742c543113b662936332c8fd97.svg";